const { REACT_APP_DEPLOY_DATE: DEPLOY_DATE = '25/02/2021' } = process.env;

export default function persistUpgrade(): void {
  try {
    const key = `PERSIST_UPGRADE_${DEPLOY_DATE}`;
    if (!localStorage.getItem(key)) {
      // Remove persist
      localStorage.removeItem('persist:root');
      localStorage.setItem(key, 'true');
    }
  } catch (err) {
    // Ignore
  }
}
